"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTypes = {
    current: 1,
    replacement: 2
};
